import { componentQrl, inlinedQrl, _jsxS, _jsxC, _IMMUTABLE, _fnSignal } from "@builder.io/qwik";
import { Blocks } from "../../components/blocks/blocks.qwik.mjs";
import { deoptSignal } from "../../functions/deopt.qwik.mjs";
const Slot = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  var _a, _b;
  return /* @__PURE__ */ _jsxS("div", {
    ...!((_a = props.builderContext.context) == null ? void 0 : _a.symbolId) && {
      "builder-slot": props.name
    },
    children: /* @__PURE__ */ _jsxC(Blocks, {
      get parent() {
        var _a2;
        return (_a2 = props.builderContext.context) == null ? void 0 : _a2.symbolId;
      },
      get path() {
        return `symbol.data.${props.name}`;
      },
      get context() {
        return props.builderContext;
      },
      get registeredComponents() {
        return props.builderComponents;
      },
      blocks: deoptSignal((_b = props.builderContext.rootState) == null ? void 0 : _b[props.name]),
      [_IMMUTABLE]: {
        context: _fnSignal((p0) => p0.builderContext, [
          props
        ], "p0.builderContext"),
        parent: _fnSignal((p0) => {
          var _a2;
          return (_a2 = p0.builderContext.context) == null ? void 0 : _a2.symbolId;
        }, [
          props
        ], "p0.builderContext.context?.symbolId"),
        path: _fnSignal((p0) => `symbol.data.${p0.name}`, [
          props
        ], "`symbol.data.${p0.name}`"),
        registeredComponents: _fnSignal((p0) => p0.builderComponents, [
          props
        ], "p0.builderComponents")
      }
    }, 3, "B1_0")
  }, {
    style: {
      pointerEvents: "auto"
    }
  }, 0, "B1_1");
}, "Slot_component_WWgWgfV0bb0"));
export {
  Slot,
  Slot as default
};
